/*
 * audit-trail reads (GET /audit/list, /audit/facets, /audit/csv). Same JWT group and grant as the
 * rest of the module; params come from audit/params.js.
 */
import { get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import { envelope_data, extract_csv_payload } from '../format';
import { build_query_string } from '../overview/params';
import { disposition_file_name } from '../shared/file_name';

const audit_url = (path, params) => {
  const query = build_query_string(params);
  return get_api_url(`/v2/cms_user/teacher_payments/audit${path}${query ? `?${query}` : ''}`);
};

export const fetch_audit_list = (params) =>
  get_api(audit_url('/list', params), true).then(envelope_data);

export const fetch_audit_facets = (params) =>
  get_api(audit_url('/facets', params), true).then(envelope_data);

// {csv, file_name}: file_name is the server's Content-Disposition name, or when unusable.
export const fetch_audit_csv = (params) =>
  get_api(audit_url('/csv', params), true).then((res) => ({
    csv: extract_csv_payload(res && res.data),
    file_name: disposition_file_name(res && res.headers)
  }));
